<template>
  <i class="icon_wrap delete_icon"></i>
</template>

<script>
export default {
  name: 'Delete'
};
</script>

<style scoped lang="stylus">
.icon_wrap.delete_icon {
  display inline-block
  width 24px
  height 24px
  background-size 24px 24px
  background-repeat no-repeat
  background-position center
  background-image url('./images/_commodity_icon_sheet_close@3x.png')
}
</style>
